import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {css} from "styled-components/macro"; //eslint-disable-line
import {SectionHeading, Subheading as SubheadingBase} from "components/misc/Headings.js";
import {PrimaryButton as PrimaryButtonBase} from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/latest/AfspraakMaken.jpeg";
import {useState} from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import Alert from '@mui/material/Alert';

// Create a custom style hook
const useStyles = makeStyles({
  whiteLoader: {
    color: '#ffffff !important', // Set the color to white
  },
});

const Container = tw.div`relative flex justify-center items-center w-full px-4 md:px-8 lg:px-12`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 w-full`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)(props => [
    tw`md:w-7/12 mt-16 md:mt-0`,
    props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto z-0 relative`;
const Image = styled.div`
    background-image: url(${props => props.imageSrc});
    ${tw`rounded-lg bg-contain bg-no-repeat bg-center h-full`}
 
 `;

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-2xl sm:text-3xl lg:text-4xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500 w-full`
const Select = styled.select`
  ${tw`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500 w-full`}
  appearance: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  border-bottom: 2px solid #d3d3d3;
  &:focus {
    border-bottom-color: #00aaff;
  }
`
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24 w-full`}
`

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`
const StyledAlert = tw(Alert)`inline-block mt-8`;

export default ({
    subheading = "",
    heading = "Contactformulier",
    description = 
        <>
          Wil je meer informatie of een afspraak maken? Neem dan contact met mij op via onderstaand formulier. Let op plaats hier geen privacy gevoelige informatie. Mijn streven is om binnen vijf werkdagen te reageren.
          <br></br>
          <br></br>
         Ben je boven de 18 jaar en heb je een verwijsbrief van de huisarts? Dan wordt de zorg (deels) vergoed. Check dit altijd eerst bij jouw zorgverzekeraar.
        </>,
    submitButtonText = "Verzenden",
    formAction = "#",
    formMethod = "get",
    textOnLeft = true,
}) => {

                    const [formState, setFormState] = useState({
                        email: '',
                        name: '',
                        geslacht: '',
                        pronouns: '',
                        telefoonnummer: '',
                        message: '',
                        voorkeursdagen: [],
                        voorkeurtijd: '',
                        locatie: '',
                    });

    const [wait, setWait] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        if (type === 'checkbox') {
            setFormState(prevState => {
                const newValues = checked
                    ? [...prevState[name], value]
                    : prevState[name].filter(v => v !== value);
                return {...prevState, [name]: newValues};
            });
        } else {
            setFormState({...formState, [name]: value});
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submit action
        try {
             setWait(true) 
            const response = await fetch('https://psychologenpraktijkbb.nl/send-email', {
                method: 'POST',
                body: JSON.stringify(formState),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                // const responseBody = await response.json();
                setSuccess(true)
                setWait(false)
                // Here, you can also clear the form or handle the UI changes accordingly
            } else {
                alert('Bericht kon niet worden verzonden, probeer je bericht te mailen naar psychologenpraktijkbb@gmail.com', response);
                setWait(false)
            }
        } catch (error) {
            console.error('Error sending email:', error);
            alert('An error occurred. Please try again.');
            setWait(false)

        }
    };
    const classes = useStyles();

    return (
        <Container>
           
        <TwoColumn>
            <ImageColumn>
                <Image  imageSrc={EmailIllustrationSrc}/>
            </ImageColumn>
            <TextColumn textOnLeft={textOnLeft}>
                <TextContent>
                    {subheading && <Subheading>{subheading}</Subheading>}
                    <Heading>{heading}</Heading>
                    {description && <Description>{description}</Description>}
                    <Form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem' }}>
        <span style={{ color: '#d3d3d3', fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem' }}>Geslacht</span>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label style={{ fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem', marginLeft: '1rem', color: formState.geslacht === "Man" ? 'black' : '#d3d3d3' }}>
            <Input
              sx={{ marginRight: '0.5rem' }}
              type="radio"
              name="geslacht"
              value="Man"
              checked={formState.geslacht === "Man"}
              onChange={handleChange}
            />
            <span style={{ marginLeft: '0.5rem' }}>Man</span>
          </label>
          <label style={{ fontFamily: 'inherit', fontSize: 'inherit', marginLeft: '1rem', color: formState.geslacht === "Vrouw" ? 'black' : '#d3d3d3' }}>
            <Input
              sx={{ marginRight: '0.5rem' }}
              type="radio"
              name="geslacht"
              value="Vrouw"
              checked={formState.geslacht === "Vrouw"}
              onChange={handleChange}
            />
            <span style={{ marginLeft: '0.5rem' }}>Vrouw</span>
          </label>
        </div>
      </div>
                        <Input
                            value={formState.pronouns}
                            onChange={handleChange}
                            type="text" name="pronouns" placeholder="Pronouns (optioneel)"/>
                                       <Input
                            value={formState.name}
                            onChange={handleChange}
                            type="text" name="name" placeholder="Achternaam"/>

                        <Input value={formState.email}
                               onChange={handleChange}
                               type="email"
                               name="email"
                               placeholder="E-mail"/>
             
                    
             <Input
    value={formState.telefoonnummer}
    onChange={handleChange}
    type="tel"
    name="telefoonnummer"
    placeholder="Telefoonnummer"
    pattern="^06[0-9]{8}$"
    title="Het telefoonnummer moet beginnen met '06' en precies 10 cijfers lang zijn"
/>
                        <Textarea
                            value={formState.message}
                            onChange={handleChange}
                            name="message" placeholder="Jouw bericht"/>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem' }}>
                            <span style={{ color: '#d3d3d3', fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem' }}>Indien u een afspraak wilt maken:</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
                            <span style={{ color: '#d3d3d3', fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem' }}>Voorkeursdag(en):</span>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                <label style={{ fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem', marginLeft: '1rem', color: formState.voorkeursdagen.includes("dinsdag") ? 'black' : '#d3d3d3' }}>
                                    <Input
                                        type="checkbox"
                                        name="voorkeursdagen"
                                        value="dinsdag"
                                        checked={formState.voorkeursdagen.includes("dinsdag")}
                                        onChange={handleChange}
                                    />
                                    <span style={{ marginLeft: '0.5rem' }}>Dinsdag</span>
                                </label>
                                <label style={{ fontFamily: 'inherit', fontSize: 'inherit', marginLeft: '1rem', color: formState.voorkeursdagen.includes("woensdag") ? 'black' : '#d3d3d3' }}>
                                    <Input
                                        type="checkbox"
                                        name="voorkeursdagen"
                                        value="woensdag"
                                        checked={formState.voorkeursdagen.includes("woensdag")}
                                        onChange={handleChange}
                                    />
                                    <span style={{ marginLeft: '0.5rem' }}>Woensdag</span>
                                </label>
                                <label style={{ fontFamily: 'inherit', fontSize: 'inherit', marginLeft: '1rem', color: formState.voorkeursdagen.includes("vrijdag") ? 'black' : '#d3d3d3' }}>
                                    <Input
                                        type="checkbox"
                                        name="voorkeursdagen"
                                        value="vrijdag"
                                        checked={formState.voorkeursdagen.includes("vrijdag")}
                                        onChange={handleChange}
                                    />
                                    <span style={{ marginLeft: '0.5rem' }}>Vrijdag</span>
                                </label>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem' }}>
                            <span style={{ color: '#d3d3d3', fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem' }}>Voorkeurtijd:</span>
                            <Select
                                name="voorkeurtijd"
                                value={formState.voorkeurtijd}
                                onChange={handleChange}
                                style={{ fontFamily: 'inherit', fontSize: 'inherit', color: formState.voorkeurtijd ? 'black' : '#d3d3d3' }}
                            >
                                <option value="" style={{ color: '#d3d3d3' }}>Geen voorkeur</option>
                                <option value="ochtend">Ochtend (09:00-12:30)</option>
                                <option value="middag">Middag (13:30-16:30)</option>
                            </Select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.5rem' }}>
                            <span style={{ color: '#d3d3d3', fontFamily: 'inherit', fontSize: 'inherit', marginRight: '1rem' }}>Op locatie of online:</span>
                            <Select
                                name="locatie"
                                value={formState.locatie}
                                onChange={handleChange}
                                style={{ fontFamily: 'inherit', fontSize: 'inherit', color: formState.locatie ? 'black' : '#d3d3d3' }}
                            >
                                <option value="" style={{ color: '#d3d3d3' }}>Geen voorkeur</option>
                                <option value="locatie">Op locatie</option>
                                <option value="online">Online</option>
                            </Select>
                        </div>
                        {success === false ?<SubmitButton type="submit">
                            {wait === false ? submitButtonText : <CircularProgress size="1rem" className={classes.whiteLoader}/>}
                            
                            </SubmitButton> : <StyledAlert variant="outlined" severity="success">
Bericht verzonden!</StyledAlert>}
                        
                     </Form>
                </TextContent>
            </TextColumn>
        </TwoColumn>
    </Container>
    );
};
